<div class="comp-registration flex flex-col h-full">

    <p class="mb-8 text-generic">
        {{ 'COMPANY_REGISTRATION.ENTER_DETAILS' | translate }}
    </p>

    <form [formGroup]="companyRegistrationForm" class="space-y-4 flex flex-col" (ngSubmit)="handleFormSubmission()">
        <app-input-field label="{{ 'COMPANY_REGISTRATION.ENTITY_NATIONAL_NUMBER' | translate }}" type="number"
            placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" [control]="entityNationalNumberControl">
        </app-input-field>
        <p class="text-sm leading-5 -mt-4" [ngClass]="{
    'text-(--text-secondary)': isEntityNationalNumberValid,
    'text-(--color-error)': !isEntityNationalNumberValid
  }">
            {{
            isEntityNationalNumberValid
            ? ('COMPANY_REGISTRATION.HELPER_TEXT' | translate)
            : ('COMPANY_REGISTRATION.INVALID_ENTITY_NUMBER' | translate)
            }}
        </p>

        <app-button text="{{ 'COMPANY_REGISTRATION.RETRIEVE_DETAILS' | translate }}" type="submit" variant="outline"
            size="lg" extraClass="mt-3" [disabled]="companyRegistrationForm.invalid">
        </app-button>
    </form>

    <!-- Placeholder when entity registration does not exists -->
    <div *ngIf="!companyDetailsFetched" class="flex flex-col justify-center items-center gap-6 my-40">
        <img src="assets/icons/retrieve-details.svg" alt="Retrieve" />
        <p class="text-center max-w-sm text-(--text-muted) font-medium text-base leading-6">
            {{'COMPANY_REGISTRATION.ENTER_ENTITY_TEXT' | translate}}</p>
    </div>


    <!-- Company Details -->
    <div *ngIf="companyDetailsFetched" class="flex flex-col mt-10">
        <div class="w-full bg-white rounded-2xl border-[0.5px] border-[#DAE1E4] overflow-hidden">
            <!-- Header Row -->
            <div class="comp-registration">
                <div class="section-header">
                    <div class="section-header-cell col-span-name">
                        {{ 'COMPANY_REGISTRATION.NAME' | translate }}
                    </div>
                    <div class="section-header-cell col-span-type">
                        {{ 'COMPANY_REGISTRATION.TYPE' | translate }}
                    </div>
                    <div class="section-header-cell col-span-legal">
                        {{ 'COMPANY_REGISTRATION.LEGAL_FORM' | translate }}
                    </div>
                    <div class="section-header-cell section-header-cell-right">
                        {{ 'COMPANY_REGISTRATION.STATUS' | translate }}
                    </div>
                </div>
            </div>

            <!-- Company Summary -->
            <div
                class="grid grid-cols-1 md:grid-cols-12 md:items-center p-6 gap-4 border-b md:border-none border-gray-100">
                <!-- Name -->
                <div class="col-span-4">
                    <div class="flex items-start gap-4">
                        <button class="mt-2 cursor-pointer" (click)="expandCompanyDetailsHandler()"><img
                                src="assets/icons/arrow-down-sm.svg" class="w-4 h-4 transition" [ngClass]="
                                {
                                    'rotate-180': expandCompanyDetails
                                }" /></button>
                        <div>
                            <p class="text-medium">
                                Al Noor Trading Company
                            </p>
                            <p class="text-medium text-base text-(--text-muted)" lang="ar">
                                شركة النور للتجارة
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Type -->
                <div class="comp-col text-medium">
                    <div class="comp-label">{{ 'COMPANY_REGISTRATION.TYPE' | translate }}</div>
                    <span class="comp-value">Private Shareholding Company</span>
                </div>

                <!-- Legal Form -->
                <div class="comp-col text-medium">
                    <div class="comp-label">{{ 'COMPANY_REGISTRATION.LEGAL_FORM' | translate }}</div>
                    <span class="comp-value">Limited Liability (LLC)</span>
                </div>

                <!-- Status -->
                <div class="comp-col md:col-span-2 md:text-right text-medium">
                    <div class="comp-label">{{ 'COMPANY_REGISTRATION.STATUS' | translate }}</div>
                    <span class="comp-status">
                        {{ 'COMPANY_REGISTRATION.ACTIVE' | translate }}
                    </span>
                </div>

            </div>

            <!-- Details -->
            <div *ngIf="expandCompanyDetails"
                class="bg-(--bg-color) rounded-b-xl p-6 text-sm font-medium text-gray-700 space-y-2">
                <div class="comp-detail">
                    <span class="comp-detail-label">{{ 'COMPANY_REGISTRATION.COMMERCIAL_REG_NUMBER' | translate
                        }}</span>
                    <span class="comp-detail-value">201345678</span>
                </div>

                <div class="comp-detail">
                    <span class="comp-detail-label">{{ 'COMPANY_REGISTRATION.TAX_NUMBER' | translate }}</span>
                    <span class="comp-detail-value">300567891</span>
                </div>

                <div class="comp-detail">
                    <span class="comp-detail-label">{{ 'COMPANY_REGISTRATION.REGISTRATION_DATE' | translate }}</span>
                    <span class="comp-detail-value">18 Sep 2024</span>
                </div>
            </div>

        </div>

        <!-- Continue Button -->
        <app-button text="{{ 'LOGIN.CONTINUE' | translate }}" type="button" variant="primary" size="lg"
            extraClass="mt-4 w-full sm:w-auto self-end" extraClass="w-full my-10"
            (action)="moveToLicenseDetails()"></app-button>
    </div>

</div>